"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketplaceChartSearchParams = void 0;
const date_fns_1 = require("date-fns");
const types_1 = require("../../../../types");
const startTimestamp = (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(new Date(), 1)).toISOString();
const endTimestamp = (0, date_fns_1.endOfMonth)((0, date_fns_1.addMonths)(new Date(), 1)).toISOString();
const marketplaceChartSearchParams = profile => ({
    [types_1.ServiceType.ADMIN]: {
        contractIds: [],
        templateIds: [],
        startTimestamp,
        endTimestamp,
    },
    [types_1.ServiceType.OFFICE]: {
        contractIds: [],
        templateIds: [],
        merchantId: profile.merchantId,
        startTimestamp,
        endTimestamp,
    },
});
exports.marketplaceChartSearchParams = marketplaceChartSearchParams;
//# sourceMappingURL=schemas.js.map